"use client";

import { HugeiconsIcon } from "@hugeicons/react";
import { Alert01Icon } from "@hugeicons-pro/core-solid-rounded";
import type { FC } from "react";

type Props = { color?: string; size?: number };

const ErrorIcon: FC<Props> = ({ color = "currentColor", size = 32 }) => (
  <HugeiconsIcon icon={Alert01Icon} size={size} color={color} />
);

export default ErrorIcon;
